import { LogLevel } from 'src/environments/environment-config';
import { jsonStringify } from '../utils/json-utils';

export class LogEntry {
  // Public Properties
  entryDate: Date = new Date();
  scope = '';
  message = '';
  logLevel: LogLevel = LogLevel.Debug;
  extraInfo: any[] = [];

  buildLogString(): string {
    let ret = '';

    ret += `[${this.scope}][${this.logLevel}] ${this.message}`;
    if (this.extraInfo.length) {
      ret += ' - Extra Info: ' + this.formatParams(this.extraInfo);
    }

    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(',');

    // Is there at least one object in the array?
    if (params.some((p) => typeof p == 'object')) {
      ret = '';

      // Build comma-delimited string
      for (const item of params) {
        try {
          // We cleared the circular ref from params before but let's be safe
          ret += jsonStringify(item, { clearCircular: true }) + ',';
        } catch (e) {
          ret += 'Could not stringify this param';
        }
      }
    }

    return ret;
  }
}
